export class Message {
  id: number;
  role: string;
  text: string;

  constructor(x: Partial<Message>) {
    this.id = x.id ?? 0;
    this.role = x.role ?? '';
    this.text = x.text ?? '';
  }
}

export class Conversation {
  id: string;
  joined: boolean;
  messages: Message[];
  guestName: string;
  supportName: string;
  endTime: Date | null;

  constructor(x: Partial<Conversation>) {
    this.id = x.id ?? '';
    this.joined = x.joined ?? false;
    this.messages = x.messages ?? [];
    this.guestName = x.guestName ?? '';
    this.supportName = x.supportName ?? '';
    this.endTime = x.endTime != null ? new Date(x.endTime) : null;
  }
}

export class getMessagesResponse {
  messages: Message[];
  constructor(x: Partial<getMessagesResponse>) {
    this.messages = x.messages?.map((m) => new Message(m)) ?? [];
  }
}

export class getQueueResponse {
  records: Conversation[];
  totalCount: number;
  pageNum: number;
  pageSize: number;

  constructor(x: Partial<getQueueResponse>) {
    this.records = x.records?.map((c) => new Conversation(c)) ?? [];
    this.totalCount = x.totalCount ?? this.records.length;
    this.pageNum = x.pageNum ?? 0;
    this.pageSize = x.pageSize ?? 10;
  }
}

export class pingChatResponse {
  conversation: Conversation;
  secondsSinceLastSupportPing: number;
  secondsSinceLastGuestPing: number;
  constructor(x: Partial<pingChatResponse>) {
    this.conversation = new Conversation(x?.conversation ?? {});
    this.secondsSinceLastSupportPing = x?.secondsSinceLastSupportPing ?? 0;
    this.secondsSinceLastGuestPing = x?.secondsSinceLastGuestPing ?? 0;
  }
}
